import { Flex, IconButton, ModeSwitcher, Typography } from '@aloft/toolkit-sui';

import { ReactNode } from 'react';

import './FilterSection.scss';

export type WithinRangeMode = 'within' | 'range';

export const EMPTY_RANGE_FILTER = {
  max: '',
  min: '',
  exact: '',
  percentage: '',
  variance: '',
} as const;

const WITHIN_RANGE_ITEMS = [
  { id: 'within', label: 'Within' },
  { id: 'range', label: 'Range' },
];

export const FilterSection = ({
  label,
  mode,
  onModeChange,
  showClear,
  onClear,
  children,
}: {
  label: string;
  mode?: WithinRangeMode;
  onModeChange?: (mode: WithinRangeMode) => void;
  showClear?: boolean;
  onClear?: () => void;
  children: ReactNode;
}) => (
  <Flex flexDirection="column" gap="12px" minWidth={0} width="100%">
    <Flex alignItems="center" justifyContent="space-between" gap="8px" minWidth={0}>
      <Flex gap="5px" alignItems="center" minWidth={0} paddingRight={showClear ? '0' : '8px'}>
        <Typography variant="h5">{label}</Typography>
        {showClear && onClear && (
          <IconButton
            ariaLabel="clear"
            icon="close-circle"
            variant="tertiary"
            onClick={onClear}
            size="xs"
            iconColor="buttonDefault"
            __dangerDoNotUseSx={{
              padding: 0,
              height: '16px',
              width: '16px',
              marginTop: '2px',
            }}
          />
        )}
      </Flex>
      {mode !== undefined && onModeChange !== undefined && (
        <div className="within-range-switcher">
          <ModeSwitcher
            items={WITHIN_RANGE_ITEMS}
            value={mode}
            variant="secondary"
            size="sm"
            onChange={(next) => onModeChange(next as WithinRangeMode)}
          />
        </div>
      )}
    </Flex>
    {children}
  </Flex>
);
